import { Link } from "react-router-dom";

export { Link };
